module.exports = __webpack_public_path__ + "img/yurt-img-4.f15f1ac5.jpg";